export default {
  ip_verification: {
    "account_banned_title": "Your account has been banned",
    "account_banned": "This account is banned. Please contact us if you need help or an explanation.",
    "changed": "Verification has been updated. Check the required country and confirm your connection again.",
    "title": "Verify your connection",
    "intro": "To help keep our community safe, please verify your connection. Once it passes verification, you can use JaTy again.",
    "country": "Required connection country",
    "country_hint": "This is your country of residence from your profile, or, if you did not provide one, the country where you are looking for a partner.",
    "step_vpn": "Turn off your VPN, proxy and other services that hide your connection.",
    "step_network": "Connect to a regular Wi-Fi or mobile network. Country: {country}.",
    "step_check": "When you are ready, confirm below. We will check your current connection.",
    "abuse_warning": "Abuse during verification may result in your account being blocked.",
    "confirm": "I am connected without a VPN — {country}",
    "checking": "Checking your connection…",
    "rejected": "Unfortunately, we cannot verify this network. Turn off your VPN and switch to another network in the required country before trying again.",
    "unavailable": "We cannot check your connection right now. Please try again shortly.",
    "connection_error": "We could not receive the result. Check your connection and try again.",
    "cooldown": "You can try again in {seconds} s.",
    "cooldown_error": "Please wait a moment before checking again.",
    "verified": "Done! Your connection has been verified.",
    "cancelled": "The administrator has removed the network verification restriction.",
    "banned_title": "Your account has been banned",
    "banned": "Your account has been automatically banned. Please contact us if you need help.",
    "contact_title": "Your account is waiting for connection verification",
    "contact_text": "Turn off your VPN and connect to a regular network in the required country: {country}. Then return to the verification window and confirm your connection. Sending a message through this form does not complete verification.",
    "contact_button": "Go to connection verification"
},
  photo_verification: {
    contact: {
      title: "Your account is waiting for photo verification",
      text: "Our safety system flagged your profile for review. Until you are verified, you cannot use the site. This is not a ban: just confirm that it is really you.",
      submitted_title: "We are checking your verification photo",
      submitted_text: "We have received your photo and you do not need to do anything else or contact us. Once we are done, your account will unlock automatically and we will email you the result. If the photo is unreadable, we will ask for a new one with a new code.",
      only_way: "Photo verification is the only way to unlock your account. We cannot unlock it through the contact form or by email, and unlock requests without a photo will not be answered.",
      button: "Go to verification",
      step_write: "Click “Go to verification” and clearly write the code you see there on a sheet of paper",
    },
    privacy: "This photo will never be public. Only our team will see it, and we delete it after verification.",
    camera_title: "Say cheese 🙂",
    camera_hint: "Hold the paper with the code next to your face:",
    shoot: "Take photo",
    cancel: "Cancel",
    camera_error: "We couldn't start the camera. Allow camera access in your browser and try again.",
    camera_unsupported: "This browser can't use the camera. Open JaTy in an up-to-date Chrome, Safari or Firefox on a phone or a computer with a camera.",
    camera_missing: "We couldn't find a camera on this device. Log in on a device with a camera, like a phone or a laptop with a webcam, and finish the verification there.",
    camera_busy: "The camera is being used by another app. Close any apps that might be using it (like video calls) and try again.",
    camera_help: "Get help",
    title: "Confirm it's you",
    intro: "We make sure JaTy is full of real people. Please complete a quick photo verification. Until then you can't use the site.",
    retry: "We couldn't confirm your identity from the previous photo. Here is a new code, please try again.",
    your_code: "Your code",
    code_hint: "The code changes every time you reload the page",
    code_loading: "Generating your code",
    step_write: "Write this code clearly on a sheet of paper",
    step_selfie: "Take a selfie holding the paper next to your face",
    step_send: "Send the photo. We'll check it as soon as we can",
    take_photo: "Take a photo",
    preview_title: "Is everything visible?",
    preview_text: "Make sure your face and the code are visible:",
    preview_alt: "Verification photo preview",
    send: "Send for verification",
    retake: "Take another photo",
    submitted_title: "Thank you! We've got your photo",
    submitted_text: "We're checking it now. Once we're done, all features will come back automatically.",
    submitted_status: "Verification in progress…",
    check_status: "Check status",
    approved: "Done! Your account is verified 🎉",
  },
  profile_view: {
    "facts_title": "At a glance",
    "open_gallery": "View photos: {name}",
    "view_gallery": "View all",
    "open_photo": "Open photo {index}: {name}",
    "photo_alt": "{name} - photo {index}",
    "photo_position": "Photo {current} of {total}",
    "close_gallery": "Close gallery",
    "previous_photo": "Previous photo",
    "next_photo": "Next photo",
    "back_to_profile": "Back to profile",
    "photo_error": "This photo could not be loaded. Please try again shortly.",
    "about_empty_title": "Not every story starts with a bio.",
    "about_empty_description": "{name} has not added a bio yet. Sometimes a few words in a conversation say more than a whole profile.",
    "details_empty_title": "These details have not been added to the profile yet. Discover more in conversation.",
    "photos_empty_description": "No photos yet - perhaps in time."
},
  consent: {
    "title": "Your privacy on JaTy",
    "description": "Essential cookies support sign-in, security and your choices. With your consent, Google Analytics measures website use and JaTy remembers your registration source. You can decline and continue using the service.",
    "necessary": "Essential – always active",
    "necessary_description": "Your session, security, selected language and saved settings. These work independently of analytics consent.",
    "analytics": "Analytics",
    "analytics_description": "Google Analytics and remembering the campaign and first page visited when you register. Declining keeps your account working but prevents us from saving this acquisition information.",
    "simple_analytics": "Aggregate Simple Analytics statistics use no cookies and respect Do Not Track. We do not link them to your account.",
    "accept": "Accept all",
    "reject": "Essential only",
    "settings": "Cookie settings",
    "save": "Save choice",
    "close": "Close settings",
    "storage_unavailable": "Your browser could not save your choice. It applies on this page; we will ask again on your next visit."
},
  login: 'Log in',
  language_picker: 'Choose language',
  login_do: 'Log in',
  logout: 'Log out',
  or: 'or',
  terms: 'Terms and conditions',
  cookies_policy: 'Cookies policy',
  privacy_policy: 'Privacy policy',
  legal_nav: {
    label: 'Legal documents',
    back_to_login: 'Back to login',
    back_to_app: 'Back to the app'
  },
  email: 'E-mail',
  password: 'Password',
  success: 'Made it!',
  comeback: 'Back',
  to: 'to',
  is: 'do',
  login_to: 'log in',
  something_wrong: 'Sorry, something went wrong',
  ask_for_another_email: 'Request a new email',
  send: 'Send',
  find_love_online: 'Find love online',
  fast_login: 'Quick login',
  hi: 'Hello',
  woman: 'Woman',
  man: 'Male',
  continue: 'Next',
  cancel: 'Cancel',
  save_changes: 'Save changes',
  premium_for_month: 'You are premium for the next month!',
  see_partners_suggestions: 'See partner suggestions',
  kilometer: 'km',
  from: 'from',
  reset_do: 'Reset',
  parameters: 'Parameters',
  change_do: 'Change',
  city: 'City',
  distance: 'Distance',
  save_parameters: 'Save parameters',
  propositions: 'Suggestions',
  hearts: 'Hearts',
  your_pairs: 'Your matches',
  your_profile: 'Your profile',
  check_profile: 'View profile',
  problem: 'Problem',
  are_you_sure: 'Are you sure?',
  change_order: 'Save order',
  yes_delete: 'Yes, delete',
  hide_menu: 'Hide menu',
  show_menu: 'Show menu',
  month: 'month',
  three_months: 'months',
  twelve_months: 'months',
  go_back_home: 'Back to home page',
  see_more: 'See more',
  and: 'and',
  close: 'Close',
  get_now: 'Get it now',
  buy_now: 'Buy Now',
  you_are_pair_with: 'You matched with',
  you_are_offline: 'It looks like you are offline. <a href="/">Reload page</a>',
  close_this_window: 'Close this window',
  not_now: 'Not now',
  not_found: 'Not found',
  something_went_wrong: 'Something went wrong :(',
  homepage: 'Homepage',
  account: {
    confirmed: 'Your account has been confirmed! You can log in! ',
    confirmed_already: 'Your account has already been confirmed',
    wrong_password: 'Wrong login or password',
    cant_login_now: 'Unable to login now',
    login: 'Log in',
    login_slogan: 'Good to see you again. See what\'s new.',
    no_account: 'You don\'t have an account?',
    your: 'Your account',
    password: {
      change: 'Change password',
      forgot: 'Forgot your password?',
      remind: 'Reset your password',
      remind_now: 'Send reset link',
      change_now: 'Change password',
      changed_successfully: 'Successful password change! You can log in ',
      check_your_email: 'Check your email',
      to_reset_password: 'to recover your password',
      current: 'Current password',
      new: 'New password',
      repeat_new: 'Repeat new password',
      change_success: 'Password changed!',
    },
    lang_choose: {
      is: 'Language selection',
    },
    notification_preferences: {
      is: 'Notification preferences',
      email_notification: 'Email notifications',
      about_hearts: 'Receive notifications about hearts you receive',
      about_pairs: 'Receive notifications about new matches',
      about_payments: 'Receive payment status notifications',
      about_messages: 'Receive notifications of new messages',
      push_status_text: 'Status of notifications on this device and in this browser',
      push_not_yet_given: 'not yet granted',
      push_given: 'granted',
      push_not_given: 'not granted'
    }
  },
  web_push: {
    on: 'Enable notifications',
    off: 'Notifications disabled',
    we_cant_turn_on: 'We cannot turn on notifications',
    manual_turn_on_help: 'To enable notifications, you must go to your browser settings and grant notification permissions for our website yourself.',
    turn_on_description: 'Enable notifications for new <br><strong>hearts</strong>, <strong>matches</strong>, <strong>messages</strong>?',
    yes_turn_on: 'Yes, enable'
  },
  chat: {
    delivery_failed: 'Message was not sent',
    delivery_unconfirmed: 'Sending not confirmed',
    retry: 'Retry',
    search: 'search ...',
    no_new: 'You don\'t have any chats',
    lets_talk: 'Let\'s talk!',
    choose_person: 'Choose the person you want to chat with.',
    no_more_messages: 'No more messages',
    load_more_messages: 'Load more messages',
    send: 'Send',
    do_you_want_to_dislike: 'Do you want to dismiss the message?',
    do_you_want_to_dislike_text: 'If you reject the message, further communication with the user will not be possible',
    yes_dislike: 'Yes, decline',
    new_messages: 'new messages',
    new_message: 'new message',
    read: 'Read'
  },
  register: {
    do: 'Register',
    on_jaty: 'Registration on JaTy',
    description_text: 'Show who you are. The rest starts with a conversation.',
    you_got_free_month: 'You got a <b>free</b>month from us!',
    social_login_error: 'Unable to login with Facebook. Probably your profile does not provide an email address.',
    or_register: 'or register',
    first_name: 'Name / nickname',
    accept_policy: 'I accept the <a href="{privacy_url}" target="_blank" rel="nofollow">privacy policy</a> and <a href="{terms_url}" target="_blank" rel="nofollow">terms and conditions</a>. '
  },
  contact: {
    do: 'Contact',
    with_us: 'Contact JaTy',
    with_us_do: 'Contact us.',
    slogan: 'Have a question? We\'re happy to help.',
    topic: 'Subject',
    describe: 'Describe your problem',
    thanks: 'Thank you for submitting the form. We will reply as soon as possible!',
    account_notice: {
      title: 'Is your question about your account? Write from your account',
      text: 'Signing in, your profile, photos, blocks, payments — sign in and use the form available once you are logged in.',
      why: 'From here we cannot confirm the account is yours, so we will not reply.',
      login: 'Sign in and write from your account',
    },
    account_modal: {
      title: 'Is your question about your account?',
      text: 'If it is, close this window, sign in and write to us using the form in the logged-in area. Only then can we see which account you mean and actually help you.',
      login: 'Sign in and write from your account',
      send: 'Not about an account — send',
    },
  },
  facebook: {
    login: 'Login with Facebook'
  },
  faq: {
    is: 'FAQ',
    how_heart_works: 'How does "heart" work?',
    how_heart_works_answer: 'A heart is a simple way to let someone know you would like to get to know them better. When you send one, the other person will be notified of your interest. If they send a heart back, you will automatically become a match and see each other in “Your matches”.',
    heart_flow_you: 'You',
    heart_flow_other_person: 'The other person',
    heart_flow_mutual: 'You both send a heart',
    heart_flow_pair: 'You can start chatting',
    make_attractive: 'How can I improve my profile on JaTy?',
    make_attractive_answer_first_part: 'It is worth completing your profile with photos and a little information about yourself. It helps people understand who you are and what you are looking for, while making the suggestions you see more relevant to you.',
    make_attractive_answer_second_part: 'Your photos matter too. Choose clear pictures where you can be seen easily and which genuinely show you. Graphics, avatars, and random images rarely make it easier to start a conversation.',
    inappropriate_content: 'Someone posted inappropriate content!',
    inappropriate_content_answer_first_part: 'On pressing the icon',
    inappropriate_content_answer_second_part: 'on a profile or user card, you can submit a report. We will review it as soon as possible and take the appropriate action. We want JaTy to be a place where everyone can feel comfortable and safe.',
    user_blocking: 'How does user blocking work?',
    user_blocking_answer: 'Once you block someone, they will no longer be able to message you or view your profile. You will not see them in suggestions or search results either. It is a discreet option when you do not want any further contact with someone.',
    no_answer: 'Didn\'t find the answer?',
    no_answer_answer: 'Send us a message using the contact form. Briefly describe what you need help with, and we will do our best to respond as soon as possible.',
  },
  safety_tips: {
    title: 'How to spot a scammer',
    intro: 'Most people on JaTy simply want to meet someone. Some accounts, however, are created to obtain money or personal data. Moderation catches many of them, but not always straight away – so it helps to know a few warning signs.',
    signs_title: 'Warning signs',
    signs: {
      money: 'A request for money in any form: a transfer, a loan, a top-up, a gift card or cryptocurrency. The reason is often moving – an illness, a ticket to visit you, customs fees for a parcel, a blocked account.',
      codes: 'A request for a BLIK code, an SMS code, online banking login details or a photo of your ID.',
      off_site: 'Pushing to move the conversation to another messenger quickly, or links to “verification”, payments or other websites.',
      too_fast: 'Very quick declarations of love and a profile that looks too perfect – while avoiding a video call.',
      investment: 'Talk about investments, cryptocurrency or a “sure way to make money” they are keen to help you with.',
      no_meeting: 'Constant excuses not to meet – working abroad, a military mission, an oil rig.',
      pressure: 'Pressure or blackmail: “only today”, “if you trust me…”, threats to publish your photos or messages.',
    },
    protect_title: 'How to protect yourself',
    protect: {
      no_money: 'Don’t send money or codes to someone you only know online – even if you have been talking for weeks.',
      no_links: 'Don’t open payment or “account verification” links from the person you are talking to. Photo verification on JaTy happens only on the site, never through a link from another person.',
      report: 'If something worries you, report the profile using the three-dot icon on it and block the person. They won’t find out who reported them.',
      meet: 'For a first date, choose a public place and tell someone you trust where you are going.',
    },
    too_late_title: 'Already sent money or data?',
    too_late: 'Don’t be embarrassed – these scams are polished and affect all kinds of people. Contact your bank straight away, change your passwords, keep screenshots of the conversation and report it to the police or to CERT Polska (incydent.cert.pl). If you are being blackmailed, don’t pay – paying rarely ends the demands. Let us know too, so we can block the account.',
    blocked_title: 'Your pair’s account has been blocked',
    blocked: 'We block accounts that broke our rules – for example through spam, attempted scams or a fake profile. We don’t share details, because the decision concerns another person. Your pair and conversation with them disappear from your list.',
    blocked_next: 'If this person asked you for money, codes or personal data, or moved the conversation outside JaTy, end that contact too and don’t send anything. If something has already happened, see the section above.',
    deleted_title: 'Your pair’s account has been deleted',
    deleted: 'This was their decision and it doesn’t mean they did anything wrong – or that it’s your fault. Your pair and conversation disappear together with the account. You will see the deletion notice in your notifications for 30 days.',
    report: 'Have a question or want to report something?',
  },
  welcome: {
    incentive: 'Complete as much information as possible in your profile to help us find the best people suggestions for you',
    sex: 'Your gender',
    looking_for_women: 'Women',
    looking_for_men: 'Men',
    looking_for: 'I\'m looking for',
    search_city: 'Tell us where you are looking for a partner',
    search_city_help: 'People nearby who are interested in you will see your profile.',
    lives_here: 'I live in the country where I am looking for a partner',
    seeking_elsewhere_warning: 'You can live in a different country from the one where you are looking for a partner. If you mention these places in your profile description, they should match the countries selected here.',
    residence_city: 'Tell us where you live',
    your_year: 'Your year',
    preferred_partner_age: 'I am looking for age partners',
    about_title: 'Write something about yourself',
    about_text: `
                <p class="mb-6">Let other people get to know you better. Write something about yourself in a few words or sentences.</p>
                <p>You can write:</p>
                <ul class="mb-6 dotted">
                    <li>what kind of person you are</li>
                    <li>what do you do and what are your hobbies</li>
                    <li>what kind of person are you looking for and what are your intentions,</li>
                    <li>are you out of words? Insert the emoji 😉</li>
                </ul>`,
    about_me: 'About me',
    smile: 'Smile!',
    images_text: `Upload your best photos to impress your profile visitors.`,
    use_face_image: 'Select a photo that shows your face,',
    max_size: 'use photos in jpg or png format up to 8MB,',
    use_your_images: 'don\'t use someone else\'s photos,',
    use_appropriate_images: 'avoid uploading offensive, nude photos.',
    images_drop: `
                <p class="is-hidden-desktop-only is-hidden-touch">
                    Click here or drag photos from your computer.
                </p>
                <p class="is-visible-desktop is-hidden-widescreen">Click here to add photos.</p>
                <p class="m-0">
                    You can change the order of the photos.
                </p>`,
    max_images: 'Maximum number of photos is 8',
    image_required: 'Photo upload is required.',
    image_from_fb: 'We downloaded your photos from Facebook\'a',
    main_after_text: 'Main photo',
    skip_this_step: 'Skip this step',
    you_can_add_images_later: 'You can add photos later from the profile editing level',
    confirm_skipping: 'Yes, go ahead',
  },
  emoji_picker: {
    most_used: 'Most used',
    people: 'People',
    nature: 'Nature',
    objects: 'Objects',
    places: 'Places',
    symbols: 'Symbols',
  },
  help: {
    is: 'Help',
    and_contact: 'Help and contact',
    center: 'Help Center',
    faq: 'FAQ',
    safety_tips: 'How to spot a scammer',
    delete_account: 'Delete account',
  },
  users: {
    send_heart: 'Send a heart',
    skip_person: 'Skip person',
    no_description: 'It is quiet here for now. Maybe a few words will appear here in time.',
    reaction_hint_title: 'Like {name}? Send a heart!',
    reaction_hint: 'Mutual hearts unlock the chat.',
    discovery_guide: {
      female_title: 'Choose your way',
      female_story: 'If someone catches your interest, send a heart and see if the feeling is mutual.',
      male_title: 'The first step is simple',
      male_story: 'If someone catches your interest, send a heart and see if the feeling is mutual.',
      instructions: 'How reactions on cards work',
      heart_action: 'Show your interest.',
      heart_description: 'Mutual hearts unlock the chat.',
      skip_action: 'Ignore.',
      skip_description: 'Hide this suggestion for a while.',
    },
    discovery_end: {
      eyebrow: 'This is not the end of the story',
      title_start: 'Choose',
      title_connector: 'or',
      title_emphasis: 'for each person',
      title_end: ', and more people will appear here soon',
      heart_label: 'heart',
      skip_label: 'cross',
      story: 'Every decision makes room for new suggestions.\nWho knows - one heart might open the door to your first conversation.',
      action: 'Finish choosing',
      technical: 'A mutual heart will open the chat automatically.',
    },
    more_actions: 'More actions for {name}\'s profile',
    first_heart: {
      title_female_1: '{name} does not know yet that you want to meet her',
      status_female_1: 'Sometimes a good conversation starts with a small sign.',
      title_female_2: 'Maybe {name} is waiting for an interesting conversation?',
      status_female_2: 'Let her know that her profile caught your attention.',
      title_female_3: 'Curious what {name} is like on the other side of the screen?',
      status_female_3: 'The first step does not need to be difficult.',
      title_male_1: '{name} does not know yet that you want to meet him',
      status_male_1: 'Sometimes a good conversation starts with a small sign.',
      title_male_2: 'Maybe {name} is waiting for an interesting conversation?',
      status_male_2: 'Let him know that his profile caught your attention.',
      title_male_3: 'Curious what {name} is like on the other side of the screen?',
      status_male_3: 'The first step does not need to be difficult.',
      action: 'Send a heart',
      technical: 'If {name} returns your interest, the chat will open automatically.',
    },
    pending_heart: {
      title_female_1: 'We know you like {name}',
      description_female_1: 'Before you can chat, {name} needs to return your gesture.',
      title_female_2: '{name} now knows you would like to meet her',
      description_female_2: 'We sent her a notification. Only her response stands between you and a conversation.',
      title_female_3: 'You have already made the first move',
      description_female_3: '{name} received your sign. When she responds, your chat will be ready.',
      reminder_female: 'No worries - we will occasionally remind her about your profile.',
      title_male_1: 'We know you like {name}',
      description_male_1: 'Before you can chat, {name} needs to return your gesture.',
      title_male_2: '{name} now knows you would like to meet him',
      description_male_2: 'We sent him a notification. Only his response stands between you and a conversation.',
      title_male_3: 'You have already made the first move',
      description_male_3: '{name} received your sign. When he responds, your chat will be ready.',
      reminder_male: 'No worries - we will occasionally remind him about your profile.',
      action: 'Cancel sent heart',
    },
    paired_heart: {
      title_female_1: 'You both sent a heart!',
      status_female_1: 'You and {name} can chat now.',
      title_female_2: '{name} returned your gesture',
      status_female_2: 'This is a good moment to send the first message.',
      title_female_3: 'This could be the start of a good conversation',
      status_female_3: '{name} wants to get to know you too.',
      title_male_1: 'You both sent a heart!',
      status_male_1: 'You and {name} can chat now.',
      title_male_2: '{name} returned your gesture',
      status_male_2: 'This is a good moment to send the first message.',
      title_male_3: 'This could be the start of a good conversation',
      status_male_3: '{name} wants to get to know you too.',
      action: 'Open chat',
      technical: 'The chat is already open for both of you.',
      cancel: 'End pairing',
    },
    incoming_heart: {
      title_female_1: '{name} has already made the first move',
      status_female_1: 'She let you know that she would like to get to know you better.',
      title_female_2: '{name} liked your profile',
      status_female_2: 'Now the next move is yours.',
      title_female_3: '{name} is interested in your profile',
      status_female_3: 'She has just made the first move.',
      title_male_1: '{name} has already made the first move',
      status_male_1: 'He let you know that he would like to get to know you better.',
      title_male_2: '{name} liked your profile',
      status_male_2: 'Now the next move is yours.',
      title_male_3: '{name} is interested in your profile',
      status_male_3: 'He has just made the first move.',
      action_female: 'I want to meet her too',
      action_male: 'I want to meet him too',
      technical: 'The chat will open as soon as you respond.',
      processing_title: 'Connecting you...',
      processing_description: 'Opening your chat with {name}.',
      decline_title: 'Do you want to decline this heart?',
      decline_description: 'This person will disappear from your received hearts list.',
      decline_action: 'Yes, skip',
    },
    open_chat: 'Open chat',
    currently_looking_at_distance: 'Currently looking within distance',
    from_city: 'town',
    near_you: 'Near you',
    lives_in: 'Lives in',
    search_parameters: 'Search parameters',
    include_living_elsewhere: 'Show people who live in another country but are looking for a partner here',
    age_you_are_looking: 'Looking for people of age',
    change_age: 'Change age',
    add_images: 'Add a photo',
    add_images_description: 'Add your photo to help others find you and unlock partner suggestions.',
    go_to_image_adding: 'Go to adding photos',
    add_photo: {
      description: 'Every connection starts with a real person. Show who you are and unlock suggestions of people you could meet.',
      action: 'Add my photo',
      hint: 'It doesn’t have to be perfect. Just make it yours.',
      your_place: 'This is your place',
      hello: 'It all starts with hello',
    },
    discovery_empty: {
      initial: {
        title: 'Good connections',
        title_accent: 'have their own timing.',
        description: 'We don’t have anyone matching your preferences right now.',
      },
      exhausted: {
        title: 'That’s everyone for now.',
        title_accent: 'See you again soon!',
        description: 'Drop by again in a while. Your next visit could bring a new connection.',
      },
      waiting: {
        title: 'Give hearts',
        title_accent: 'a moment to find their way to you.',
        description: 'No one has sent you a heart yet. Check back later - that may be when someone makes the first move.',
      },
      sent: {
        title: 'A good conversation can start',
        title_accent: 'with one heart.',
        description: 'You have not sent a heart to anyone yet. Meet new people - one of them might be the start of something meaningful.',
      },
      return_message: 'Come back soon - someone might surprise you.',
      links_label: 'Explore in the meantime',
      discover_action: 'Meet new people',
      sent_hearts_action: 'Sent hearts',
      received_hearts_action: 'Received hearts',
      profile_action: 'Your profile',
      photos_action: 'Your photos',
      hearts_action: 'Hearts',
      pairs_action: 'Your matches',
    },
    want_to_see_more: 'Want to see more people?',
    go_change_your_preferences: 'Adjust your preferences to see more people suggestions.',
    change_preferences: 'Change parameters',
    card: {
      active_now_w: 'Active now',
      active_now_m: 'Active now',
      active_recently_w: 'Active recently',
      active_recently_m: 'Active recently',
      no_photo: 'No photo yet',
      liked_you: 'You got a heart',
      your_move: 'Your move!',
      like_back: 'Send a heart back and start chatting right away.',
      photos: 'Profile photos',
      photo: 'Photo {number}: {name}',
      show_photo: 'Show photo {number}',
      previous_photo: 'Previous photo',
      next_photo: 'Next photo',
    },
    he_sent_you_a_heart: 'He sent you a heart',
    she_sent_you_a_heart: 'She sent you a heart',
    height: 'Height',
    physique: 'Body structure',
    children: 'Children',
    eye_color: 'Eye color',
    marital_status: 'Marital status',
    work: 'Work',
    education: 'Education',
    confession: 'Confession',
    attitude_to_marriage: 'Attitude to marriage',
    report: 'Report',
    block: 'Block',
    report_user: 'Report user',
    reason: 'Reason',
    ugly_profile: 'Offensive profile - photos / description',
    report_other: 'Other',
    stealing_personal_data: 'Attempt to extort personal data',
    stealing: 'Attempted to steal / extort money',
    hate_talk: 'Propagating Hatred',
    fake: 'Spoofing (suspected fake account)',
    also_block_user: 'Block the user additionally',
    sure_to_black_and_unpair: 'Are you sure you want to block the user and break the couple?',
    sure_to_black: 'Are you sure you want to block the user?',
    block_user: 'User lock',
    yes_block: 'Yes, block',
    blocked: 'User has been blocked',
    thanks_for_report: 'Thank you for reporting',
    write_more: 'write more...',
    looking_for: 'I\'m looking for',
    looking_for_women: 'women',
    looking_for_men: 'men',
    aged: 'in&nbsp;age',
    click: 'Press',
    and_start_talking: 'and start chatting <br>chat!',
    visits: 'Visits',
    images: 'Photos',
    who_visited_you: 'Who visited you?',
    deleted: 'The selected user does not exist',
    one_time: 'time',
    times: 'times',
    no_new_visits: 'You have no new visits',
    users_not_found: 'User not found',
    not_found_page: {
      title: 'This user does not exist',
      reasons_intro: 'Possible reasons:',
      reason_link: 'the link is wrong or incomplete',
      reason_deleted: 'the user deleted their account',
      reason_banned: 'the account has been blocked',
      back: 'Back to suggestions'
    },
    pair: {
      are_you_sure_to_break: 'You want to break a couple',
      are_you_sure_to_break_confirm: 'Are you sure you want to do this?',
      yes_break: 'Yes, break it'
    },
    heart: {
      cancel_q: 'Do you want to cancel the heart?',
      cancel_confirm: 'The heart you sent earlier will be canceled.',
      yes_cancel: 'Yes, cancel the heart',
    }
  },
  current_user: {
    edit_profile: 'Edit Profile',
    edit_images: 'Edit Photos',
    basic_info: 'Basic information',
    edit_success: 'Editing profile successful!',
    edit_cooldown: 'You can only change your name, year of birth, city, place of residence and gender once in a while.',
    more: {
      about_me: 'More about me'
    },
    preferences: {
      is: 'Preferences'
    },
    images: {
      is: 'Your photos',
      header: 'Present your <span>best</span>side!',
      from_computer: 'Click here or drag photos from computer',
      from_mobile: 'Click here to add photos',
      can_change_order: 'You can change the order of the photos.',
      uploaded_images: 'Uploaded photos',
      max_size_image: 'The {name} photo cannot be larger than 8MB',
      order_changed: 'Order editing successful!',
      confirm_delete: 'Delete photos',
      confirm_delete_text: 'Are you sure you want to do this? This operation cannot be undone? ',
    },
    lang: {
      choose: 'Language Selection'
    }
  },
  profile: {
    edit: 'Edit profile'
  },
  premium: {
    is: 'Premium',
    account: 'Premium account',
    buy: 'Your premium',
    see_with: 'View From',
    PREMIUM: 'PREMIUM',
    to: 'Your account is premium to',
    see_benefits: 'See premium benefits',
    hide: 'Hide',
    benefits: 'Benefits',
    free: 'Free',
    no_ads: 'No Ads',
    be_higher: 'Display above <span class="is-hidden-mobile">other users</span>',
    ukraine: `🇺🇦 100% of payments made by our users in the period 05/03/2022 will be donated until further notice <a
href="https://pomagam.pl/solidarnizukraina" target="_blank" rel="nofollow">🇺🇦 "Solidarni z Ukrainą"</a>
organized by the <a href="https://pomagam.pl/" target="_blank" rel="nofollow">pomagam.pl</a>foundation.
Documentation of this initiative will be available on our profile on <a
href="https://www.facebook.com/jatyportalrandkowy" target="_blank" rel="nofollow">facebook</a>. We encourage you to
like 🇺🇦`,
    see: 'View',
    more_with: 'More benefits from',
    expires: 'You are premium to'
  },
  like: {
    hearts: 'Hearts',
    sent: 'Sent',
    received: 'Received',
    you_didnt_sent_to_anyone: 'You haven\'t sent a heart to anyone yet',
    go_to_propositions_to_like: 'Go to the suggestions and connect with people who match your preferences.',
    sent_hero_title: 'Hearts',
    sent_hero_description: 'The people you liked will see your heart. When they return the interest, the chat will open.',
    sent_hero_story: 'Waiting for a heart in return',
    received_hero_title: 'Hearts',
    received_hero_story: 'Return it and start chatting',
    linking_description: 'Someone sent you a heart? Return it to create a match and start chatting right away.',
    nobody_sent_you: 'Nobody has sent you a heart yet'
  },
  pair: {
    yours: 'Your matches',
    page_description: 'Here you see people you like and they are liking you',
    no: 'You don\'t have any couple yet'
  },
  delete_request: {
    title: 'Delete account',
    stay_eyebrow: 'Before you go',
    stay_title: 'Every conversation on JaTy can be the start of something meaningful',
    stay_text: 'We are building JaTy together with the people who use it. Give yourself - and us - one more chance: a new profile, one heart, or a simple hello can sometimes lead further than expected.',
    stay_action: 'Meet more people',
    description: `
    <p class="mb-2">Deleting your account permanently removes:</p>
    <ul class="mb-2 dotted">
      <li>your data,</li>
      <li>your photos,</li>
      <li>your message history,</li>
      <li>your subscription.</li>
    </ul>
    <p class="mb-2">We do not send emails about this process, so:</p>
    <ul class="dotted mb-2">
      <li><b>No,</b> you will not receive a notification when your account is deleted.</li>
      <li><b>No,</b> you will not receive a notification when the request is sent.</li>
      <li><b>No,</b> you will not receive notifications about additional questions.</li>
    </ul>
    <p class="mb-2">For 30 days, people you have a pair or conversation with will see a notification that your account was deleted, together with your name or nickname.</p>
    <p class="has-text-danger delete-text mb-2">This process cannot be undone.</p>
    <p class="mb-2">You can register again, but your current account will no longer be available.</p>
    <p class="mb-0">If you still want to delete your account, tell us what we could improve and submit your deletion request.</p>`,
    reason: 'What did you dislike most about our portal? (mandatory)',
    ask: 'Ask to delete account',
    cant_cancel: `
      <div class="content">
        <p class="has-text-centered has-text-primary is-size-3 mb-2">♡</p>
        <p class="has-text-weight-semibold has-text-centered">Remember that this process cannot be undone.</p>
        <div class="notification is-info has-text-white">
          JaTy is free, so you do not lose anything by staying a little longer. Give yourself a chance to meet someone valuable, start a conversation or find love when you least expect it.
        </div>
      </div>
      `,
    yes_delete: 'Yes, ask for account deletion',
    no: 'I will stay and try again',
    last_step: 'Last step',
    press_yes_to_delete: 'Press "Yes" if you want to permanently delete your data',
    permanently: 'Yes, permanently delete account'
  },
  email_confirmation: {
    resend: 'Send again.',
    didnt_received: 'Email not received?',
    go_to_email: 'Go to your e-mail to confirm it',
    mail_sent: 'Mail has been sent',
    already_send_in_10_minutes: 'You asked to resend your email in the last 10 minutes',
    on_mail: 'to mailbox',
    you_she_received: 'got',
    you_he_received: 'got',
    email_sent_from_us: 'an email from us with instructions on how to confirm your account.',
    do_now: 'Confirm your email address!',
    great_last_step: 'Great! The last step!',
    delivered_hint: 'We checked - this email did leave our side. If you cannot find it, look in spam and promotions.',
    contact: {
      title: 'We checked - your confirmation email did leave our side',
      text: 'We have confirmation that the message with the confirmation link was sent to this address:',
      where_to_look: 'Before writing to us, check your Spam, Promotions and Updates folders and search for "JaTy". We cannot confirm the account for you - the link in that email has to be clicked.',
    },
  },
  payment: {
    you_save: 'Save',
    mon: 'month',
    choose_one: 'Choose one of the options',
    go_to_p24: 'Go to Przelewy24',
    thanks_title: 'Thank you for paying for the order!',
    thanks_text: 'We will inform you as soon as we get information about your payment.',
    choosen: 'Selected',
    digital: {
      active: 'You don\'t need to do anything else. Your subscription is active.',
      deactived_globally: 'In-app payments disabled.',
      manage: 'Manage subscription',
      active_now: 'Activate now',
      seven_days_free: '7 days free',
      with_subscription: 'subscription',
    },
  },
  alert: {
    is: 'Notifications',
    description: 'You can see a list of notifications that allow you to control what\'s new in your account.',
    read_all: 'Mark all read',
    no_new: 'You have no new notifications',
    nothing: 'Nothing interesting is happening',
    see_all: 'See all notifications',
    one_more_step: 'One more step',
    new: 'New',
    add_more_info_about_you: 'Complete information about yourself',
    you_are_premium: 'You are premium',
    your_account_is_premium: 'Your account has been extended',
    you_are_pair: 'You are a couple',
    description_warning: 'Your profile description was removed',
    photos_warning: 'Your profile photos were removed',
    you_received_warning_for_description: 'You received a warning because your profile description did not meet our rules',
    you_received_warning_for_photos: 'You received a warning because your profile photos did not meet our rules',
    pair_banned: 'Account blocked for breaking our rules. Don’t send this person money or codes – see what to watch out for',
    pair_deleted: 'Account deleted. Your pair and conversation were removed with it',
  },
  profile_photo_rules: {
    label: 'Photo upload guidelines',
    face: 'Your face must be clearly visible in your main photo.',
    forbidden: 'Do not upload',
    sexual: 'Nudity, sexually explicit poses or sexual content.',
    clothing: 'Photos in underwear. Swimwear photos outside an appropriate setting, such as a beach or pool.',
    children: 'Photos of children without a parent or guardian visible beside them.',
    identity: 'Group photos, photos belonging to someone else or any images that do not show you.',
    offensive: 'Offensive content, violence or hateful imagery.',
  },
  profile_description_rules: {
    title: 'Public profile description rules',
    text: 'Do not add contact details or links to messengers and social media. Do not add advertising or direct sexual propositions. Breaking these rules may result in your description being removed and a warning.',
    link: 'Read the full description rules'
  },
  premium_box: {
    twa: `
     <span class="has-text-primary">Premium</span>for 7 days for FREE! Then&nbsp;<span
              class="has-text-danger">50&#37;</span>&nbsp; discounts.`,
    left: 'Left',
    countdown_text: `<span class="has-text-primary">Premium</span> for <span class="countdown-price">29.99 & nbsp; PLN</span>
             <span class="countdown-promo-price has-text-danger">69.99 & nbsp; PLN</span>
              for 12 months!<br>`,
    text: `JaTy becomes <span class="has-text-primary">free</span>for everyone! From March 5th
           2022 premium has only two benefits: "no ads" and "being slightly higher in the results
           search". The rest of the functionality becomes free!<br><br>🇺🇦 100% of payments made by ours
           users in the period 05.03.2022 until further notice, we will donate to a fundraiser
          <a href="https://pomagam.pl/solidarnizukraina" target="_blank" rel="nofollow">🇺🇦"Solidarity with Ukraine"</a>
           organized by the<a href="https://pomagam.pl/" target="_blank" rel="nofollow">Pomagam.pl</a>foundation.
           Documentation of this initiative will be available on our profile on <a
           href="https://www.facebook.com/jatyportalrandkowy" target="_blank" rel="nofollow">facebook</a>.
           We encourage you to like 🇺🇦`
  },
  city_chooser: {
    loading: 'Loading',
    no_results: 'No results',
    no_results_residence: 'Cities in the country where you are looking for a partner are not offered here. If you live in that country too, check “I live in the country where I am looking for a partner”.'
  },
  home: {
    chat_image_alt: 'A chat conversation on the JaTy dating site',
    app_image_alt: 'The JaTy dating site on a phone and computer',
    moderation: `
          <p class="mb-3">
            The JaTy team responds to abuse and bans accounts that break our rules.
            Artificial intelligence (AI) supports this work by helping review profiles, moderate content and detect suspicious behaviour.
            This helps us tackle fake accounts, spam and attempted scams more efficiently.
          </p>
          <p class="mb-3">
            AI helps us look after the space where people meet. You decide who to talk to, who to send a heart to
            and whether to meet in person. We want you to spend more time getting to know people
            and less time dealing with unwanted attention.
          </p>
          <p>
            No moderation system catches every problem, and mistakes can happen.
            If something concerns you, use the report option on the user’s profile.
            For problems with your account or the site, you can also <a href="{contact_url}">contact the JaTy team</a>.
            Your reports help us look after the community.
          </p>`,
    h1: 'Free Dating Site',
    go_for_jaty: 'Go to JaTy',
    login: 'Log in',
    register: 'Sign up',
    thousands_of_users: 'Thousands of users',
    every_day_new_users: 'New users every day!',
    totally_free: 'Completely free',
    all_features_free: 'All features are available for free!',
    only_real_accounts: 'Active moderation',
    accounts_constantly_verified: 'Our team, supported by AI',
    safe_guarantee_title: 'Your safety matters',
    ssl: 'SSL certificate',
    spam_filter: 'Spam filter',
    fake_control: 'Fake profile detection',
    hero_intro: 'Meet someone you want to keep talking to. Love, friendship, or a first coffee together?',
    hero_note: 'Free to use. At your pace. Adults 18+.',
    about_label: 'About us',
    about_heading: 'Get to know JaTy',
    about_intro: 'It began as an idea for a dating site for friends. Today we are building an independent, free place to meet people. Find out who is behind JaTy and what matters to us.',
    about_link: 'More about JaTy',
    how_it_works: 'How it works',
    discover: 'See how it works',
    chat_graphic_section_h1: 'Meet singles and make meaningful connections',
    chat_intro: 'A few simple steps to a new connection. You decide what comes next.',
    steps: [
      {
        title: 'Be yourself',
        text: 'Add a photo and a few words about yourself. Choose who you would like to meet.'
      },
      {
        title: 'Send a heart',
        text: 'Browse profiles. When you like each other, you become a match.'
      },
      {
        title: 'Start talking',
        text: 'Send that first message. Meet in person when you both feel ready.'
      }
    ],
    free_heading: 'JaTy is a <strong class="has-text-primary">free</strong> dating site',
    free_intro: 'Chat, hearts and matching are free. No subscriptions or payments to unlock a conversation.',
    free_label: 'for all features',
    free_features: [
      'Chat',
      'Hearts',
      'Matching',
      'Search'
    ],
    safety_intro: 'Our team reviews content and responds to abuse with AI support. You choose who you want to talk to.',
    moderation_heading: 'How do AI and our team help make online dating safer?',
    online_to_live_heading: 'Online dating can become a real-life date',
    online_to_live: `
          <p class="mb-3">
            JaTy is an online dating site that helps you build long-term relationships, but it can also help you meet new friends for a walk, a drink, coffee or a movie.
            The internet makes the first step easier, especially when everyday life gives you little time or few chances to meet someone new.
          </p>
          <p class="mb-3">
            A good conversation often shows whether you share a similar sense of humor, values, plans and lifestyle.
            That is why online dating can become something very real: a first meeting, a weekend together, a serious relationship or a friendship that lasts.
          </p>
          <p>
            JaTy works in your browser, so you can use it on a phone, tablet or computer without installing a mobile app.
            Your profile and conversations are available wherever you have internet access, at home, while travelling or whenever you have a quiet moment during the day.
          </p>`,
    app_label: 'Always within reach',
    faq_title: 'JaTy Free Online Dating - Frequently Asked Questions (FAQ)',
    faq_intro: 'A few answers before your first “hello”.',
    faq_items: [
      {
        question: 'Is JaTy really a free dating site?',
        answer: `<p>
              Yes. Messages, hearts, matching, profile browsing and search are available for free.
              JaTy does not require a paid subscription, premium package or one-time payment to unlock contact.
            </p>
<p class="mt-1">The features needed for online dating are available without payment.</p>`
      },
      {
        question: 'Why is JaTy free?',
        answer: `<p>
              We want to give users a real chance to find love, friendship or a meaningful connection without charging for the basic ability to talk.
              That is why we focus on simple dating tools, safety, reducing vulgar content and checking suspicious or fake accounts.
            </p>`
      },
      {
        question: 'Who can I meet on JaTy?',
        answer: `<p>
              JaTy brings together people from Poland and other places who are looking for love, friendship, conversation or a serious relationship.
              We care about limiting fake profiles and dishonest behaviour. No dating site can promise that every profile will be perfect, but we keep working to make the JaTy community as authentic and safe as possible.
            </p>`
      },
      {
        question: 'Is registration difficult?',
        answer: `<p>
              No. <a href="{register_url}">Registration</a> on JaTy is simple and takes only a moment.
              After creating an account, you can complete your profile, add a photo, set your preferences and start meeting people who are also interested in online dating.
            </p>`
      },
      {
        question: 'Can I use JaTy without a mobile app?',
        answer: `<p>
              Yes. JaTy currently works as a dating site in your browser. You can use it on a phone, tablet or computer without installing a mobile application.
              This is convenient if you want access to your profile and messages from different devices.
            </p>`
      },
      {
        question: 'How do dating sites work?',
        answer: `<p>
              Different dating sites use different features, but the goal is usually the same: helping people meet someone with whom they can build a relationship, friendship or love.
              On JaTy you can browse profiles, send hearts, use matching and write messages when someone interests you.
            </p>`
      },
      {
        question: 'Who is JaTy for?',
        answer: `<p>
              JaTy is for adult singles, lonely people, shy people, busy people and anyone who wants to meet others online in a calm and natural way.
              You can look for a serious relationship, friendship, conversation or someone to meet for a walk, coffee, a drink or a movie.
            </p>`
      },
      {
        question: 'Is JaTy only for adults?',
        answer: `<p>
              Yes. JaTy is available only to adults. It is not a place for scams, earning money from other users or publishing vulgar content.
              Our goal is to help people meet real users and build normal, honest relationships.
            </p>`
      },
      {
        question: 'How do we protect your data?',
        answer: `<p>
              People who are not registered on the portal cannot see you or your profile data.
              We do not share user data with third parties for purposes that conflict with the operation of the service.
              JaTy uses security standards designed to help users stay private outside the portal and decide for themselves who should learn more about them.
            </p>`
      }
    ],
    closing_intro: 'Create a free account. Let someone get to know you.',
    footer_note: 'A place for new connections.',
    chat_graphic_section: `
          <p class="mb-3">
            JaTy is a free dating site created for people who want to meet someone real online.
            Whether you are looking for love, friendship, a serious relationship or simply a good conversation, online dating can make the first step easier.
            You do not need to install an app or pay before you can start discovering profiles and talking to other people.
          </p>
          <p class="mb-3">
            On JaTy you can meet singles from Poland and beyond, browse profiles, send hearts, use matching features and start conversations when someone catches your attention.
            For shy people, busy people and anyone who finds it difficult to meet someone new in everyday life, a dating website can be a natural way to begin.
          </p>
          <p class="mb-3">
            The goal is simple: help adults find meaningful connections in a place that feels clear, accessible and safe.
            Some users are looking for a long-term partner, others want to make friends, go for a walk, have coffee, go to the cinema or slowly build trust through messages.
          </p>
          <p>
            JaTy gives you the basic tools you need for free online dating: profiles, chat, hearts, matching and search.
            Create an account, write a few honest words about yourself and start meeting people at your own pace.
          </p>`,
    free_heading_text: `
          <p class="mb-3">
            JaTy works as a free dating site: messages, hearts, matching, profile browsing and search are available without payment.
            We believe that the most important online dating features should be open to users who are looking for love, friendship or a meaningful relationship.
          </p>
          <p class="mb-3">
            Free online dating should not mean creating an account only to discover that every real conversation is locked behind a subscription.
            With JaTy you can start writing, react to profiles, check matches and meet new people without subscriptions, premium packages or paid unlocks.
          </p>
          <p>
            The core idea stays the same: a dating portal should help people meet online, not block the first message behind a paywall.
          </p>`,
    we_will_help_you_for_free_heading: 'JaTy helps you look for love for free!',
    we_will_help_you_for_free: `
          <p class="mb-3">
            Would you like to meet someone you connect with? Do you feel lonely? Are you single and ready to try online dating without pressure or hidden costs?
            If so, the free dating site JaTy is a good place to begin.
          </p>
          <p class="mb-3">
            Sign up, complete your profile and write a few natural sentences about who you are and who you would like to meet.
            The more honest your profile is, the easier it becomes to start a conversation with someone who is looking for the same thing: love, friendship, a serious relationship or a new connection.
          </p>
          <p class="mb-3">
            We do not promise magic or a ready-made formula for love. What we do offer are simple tools that make the first contact easier: profiles, search, hearts, matching and messages.
            Sometimes one conversation is enough to make the day feel lighter and to start a connection that grows in a good direction.
          </p>
          <p>
            JaTy is for people who want to meet others without pretending to be someone else.
            You can take your time, decide who you want to reply to and move from online dating to a real-life meeting only when you feel ready.
          </p>`,
    app_heading: 'Free online dating in your browser',
    app: `
          <p class="mb-3">
            The JaTy dating site works conveniently in the browser on your phone and computer.
            You can log in with the same account, browse profiles, send hearts, use matching and write messages without installing an additional app.
          </p>
          <p class="mb-3">
            Browser-based dating is simple: it does not take storage space on your phone, does not require app updates and lets you use the service on different devices.
            Open JaTy, log in and return to your conversations whenever you have time.
          </p>
          <p>
            We want the portal to be clear, fast and comfortable both on a smartphone and on a larger screen.
            That way you can meet new people in a way that fits your day: in the morning, after work or in the evening when you finally have a moment for yourself.
          </p>`,
    read_more: 'Read more',
    read_less: 'Show less'
  },
  meta: {
    home: 'Meet singles on JaTy, a free dating site with chat, hearts and matching. Find new connections in a community moderated by our team with AI support.',
    login: 'Log in to JaTy to return to your conversations, check your hearts and meet new people on our free dating site.',
    contact: 'Contact the JaTy team for help with your account, to report a problem or to ask a question about using the dating site.',
    logout: 'Log out - JaTy is a free online dating site for singles, lonely people and everyone who wants to meet valuable people online.',
    register: 'Create a free JaTy account. Add a photo, complete your profile and meet singles. Chat, send hearts and find matches without subscriptions or fees.',
    redirect: 'Find love online - JaTy is a free dating site for singles looking for conversation, friendship, a serious relationship and real connections.',
    fast_login: 'Quick login - Return to JaTy and continue free online dating, conversations, matching and meeting new people in a safe dating portal.',
    login_layout: 'JaTy is a free online dating site where you can meet valuable people, start conversations and look for love for free.',
    regulamin: 'Read the JaTy terms and conditions, including registration requirements, user rights and responsibilities, and rules for using your account.',
    polityka_prywatnosci: 'Learn how JaTy processes personal data, what rights you have and how to contact us about your information.',
    cookies: 'Learn how JaTy uses cookies and how to manage them in your browser settings.'
  },
  title: {
    home: 'JaTy - free dating site and online chat',
    login_layout: 'JaTy - free online dating',
    help: 'Help Center - JaTy Online Dating',
    safety_tips: 'How to spot a scammer - JaTy Online Dating',
    welcome: {
      index: 'Hello - JaTy Online Dating',
      about: 'Hello - JaTy Online Dating',
      images: 'Photos - JaTy Online Dating'
    },
    users: {
      index: 'Suggestions - JaTy Online Dating',
      liked: 'Hearts - JaTy Online Dating',
      liking: 'Hearts - JaTy Online Dating',
      _slug: '- JaTy Online Dating'
    },
    'current-user': {
      'verify-email': 'Validate your email',
      payments: {
        digital: 'Premium - JaTy Online Dating',
        index: 'Premium - JaTy Online Dating',
        thanks: 'Thank you - JaTy Online Dating'
      },
      edit: {
        'delete-request': 'Account deletion - JaTy Online Dating',
        images: 'Photos - JaTy Online dating',
        index: 'Basic information - JaTy Online Dating',
        lang: 'Language selection - JaTy Online Dating',
        'notification-preferences': 'Notification preferences - JaTy Online Dating',
        password: 'Change password - JaTy Online Dating',
        preferences: 'Preferences - JaTy Online Dating',
        profile: 'More about me - JaTy Online Dating'
      }
    }
  },

  terms_of_use: `<article class="legal-doc">
    <header class="legal-doc__header">
      <h2 class="legal-doc__title">General Terms of Service Provision</h2>
      <p class="legal-doc__subtitle">hereinafter referred to as the “General Terms”</p>
    </header>

    <div class="legal-doc__intro">
      <p>These General Terms and Conditions govern the use of the Jaty website (the “Jaty Service”). The operator of the service and the party to the contract with the Customer is WHIPO sp. z o.o., a Polish limited liability company with its registered office at ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118, hereinafter referred to as “Jaty”. Contact: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
      <p>Upon registration on the Website, the Customer declares and warrants that he has read and accepted the General Terms and Conditions. The general terms and conditions therefore form an integral part of the contract.</p>
      <p>The general conditions apply to all customers.</p>
      <p>People over 18 years of age may use the Jaty Service.</p>
    </div>

    <nav class="legal-doc__toc" aria-label="Table of contents">
      <p class="legal-doc__toc-title">Contents</p>
      <ol>
        <li><a href="#pkt-1">1. Subject of the contract</a></li>
        <li><a href="#pkt-2">2. Using the Service and concluding a contract</a></li>
        <li><a href="#pkt-3">3. Jaty service and scope of services</a></li>
        <li><a href="#pkt-4">4. Contact and notifications</a></li>
        <li><a href="#pkt-5">5. Liability of the Jaty Website</a></li>
        <li><a href="#pkt-6">6. Customer Responsibilities</a></li>
        <li class="legal-doc__toc-highlight"><a href="#moderacja">6a. Profile, message, warning and ban rules – AI moderation and appeals</a></li>
        <li><a href="#pkt-7">7. Data protection, data processing and cookies</a></li>
        <li><a href="#pkt-8">8. Termination of the contract and cessation of services</a></li>
        <li><a href="#pkt-9">9. Complaints</a></li>
        <li><a href="#pkt-10">10. Copyright</a></li>
        <li><a href="#pkt-11">11. The right to withdraw from the contract</a></li>
        <li><a href="#pkt-12">12. Change of the General Conditions</a></li>
        <li><a href="#pkt-13">13. Others</a></li>
      </ol>
    </nav>

    <section id="pkt-1" class="legal-doc__section">
      <h3>1. Subject of the contract</h3>
      <ol class="legal-doc__clauses">
        <li>
          <p>The contract covers services provided free of charge. Registration and all website features, including browsing profiles, searching, sending hearts, matching and messaging, are free. Jaty offers the following services (see also section 3, “Jaty service and scope of services”):</p>
          <ul>
            <li>Customer introduction to the Service database and data management;</li>
            <li>Enabling contact with other Customers of the Jaty Service.</li>
          </ul>
        </li>
        <li><p>The subject of the contract between the Customer and the Jaty Service Center is neither marriage matching, matrimonial mediation, nor activity aimed at establishing a partnership or marriage.</p></li>
        <li><p>Jaty is for meeting people privately. Advertising campaigns, spam and using the service for fraud are prohibited. Section 6a sets out the detailed rules.</p></li>
        <li><p>To use the Jaty Website, it is necessary to have devices that allow the use of the Internet, an e-mail mailbox and a web resource browser that allows displaying WWW pages.</p></li>
      </ol>
    </section>

    <section id="pkt-2" class="legal-doc__section">
      <h3>2. Using the Service and concluding a contract</h3>
      <ol class="legal-doc__clauses">
        <li><p>The use of the Jaty Service requires registration. During registration, the Customer provides a first name under which they will be visible to other customers of the Service, and sets a password. The e-mail address provided is used only for contacting the Service of Jaty with the Client and is not passed on to other Clients of the Service of Jaty.</p></li>
        <li><p>By registering, the Customer accepts these General Terms and Conditions and declares that he or she is of legal age, i.e. at least 18 years of age.</p></li>
        <li><p>The contract between the Customer and the Jaty Service Center is concluded upon the Customer's registration. These General Terms and Conditions apply to this agreement. Registration is free.</p></li>
        <li><p>Jaty does not currently offer paid accounts, paid packages or subscriptions. Access to website features does not require accepting any obligation to pay.</p></li>
        <li><p>The Customer declares that the information provided during registration is accurate.</p></li>
        <li><p>Jaty may block access to the service if the Customer violates the law, the rights of third parties or the obligations set out in <a href="#pkt-6">section 6, “Customer Responsibilities”</a>. In the event of a serious breach of these General Terms and Conditions or the contract, Jaty may pursue remedies available under applicable law.</p></li>
      </ol>
    </section>

    <section id="pkt-3" class="legal-doc__section">
      <h3>3. Jaty service and scope of services</h3>
      <ol class="legal-doc__clauses">
        <li><p>The provision of services by the Jaty Website begins upon registration. The Customer completes their profile, which is visible to other users of the Jaty Service.</p></li>
        <li><p>The Jaty Service allows Customers to browse and search profiles, send hearts and match. Messages can be exchanged with people the Customer has matched with (after both sent hearts), via the internal communication system of the Jaty Website. The Jaty Service may suggest profiles that may suit the Customer.</p></li>
        <li><p>Making contact and sending messages are free of charge.</p></li>
        <li><p>Jaty does not currently charge for access to website features. If the scope of services changes in the future, the Customer will be informed in accordance with applicable law and these General Terms and Conditions.</p></li>
        <li>
          <p>Jaty Website does not guarantee that the data provided by the Customers is true.</p>
          <p>Jaty Website does not guarantee that the contact will be made effective during the term of the contract.</p>
        </li>
        <li><p>Basically, the service provided by Jaty is available 24/7. Availability is estimated at 95% on an annual basis. The above value does not include interruptions related to the maintenance or update of the software or caused by factors that are not dependent on Jaty, such as unavailability of Internet services due to the fault of third parties or due to force majeure. Jaty recommends using an up-to-date browser. Where outdated or non-standard technology is used, Jaty cannot guarantee the proper operation of all services and features.</p></li>
      </ol>
    </section>

    <section id="pkt-4" class="legal-doc__section">
      <h3>4. Mutual notifications made by the Customer and Jaty Service</h3>
      <ol class="legal-doc__clauses">
        <li><p>Jaty sends messages to the Customer in the service after logging in or to the email address associated with the account.</p></li>
        <li><p>The Customer may contact Jaty by email at <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a> or via the contact form. For verification and protection against abuse, the Customer should write from the email address associated with the account or provide that address and their username.</p></li>
      </ol>
    </section>

    <section id="pkt-5" class="legal-doc__section">
      <h3>5. Liability of the Jaty Website</h3>
      <ol class="legal-doc__clauses">
        <li><p>The Jaty website is not responsible in any way, within the limits consistent with applicable law, for the materials and data provided and published on the Jaty website by customers and for their truthfulness, reliability and authenticity. If we learn that the client is in breach of legal regulations; violates one or more of the rights of a third party or breaches the customer's existing obligations under clause 6, then clause 2.6 will apply.</p></li>
        <li><p>Direct contact between Jaty's Service Clients takes place only with mutual consent (see section 3 “Jaty's Service and the scope of services”). Jaty's Service is therefore not liable if no contact is made during the term of the agreement. Jaty Service makes every effort to mediate in contacts between Jaty Service Customers by ensuring appropriate technical conditions.</p></li>
        <li><p>Jaty's website is not responsible for the misuse of data and information by others, because despite the express prohibition (see point 6 “Customer's obligations”), customers may use the Jaty's website in violation of the law. Jaty's website is therefore also not responsible when the information that the Customer himself has made available to a third party is used unlawfully by a third party.</p></li>
        <li><p>Jaty does not guarantee that the service will be error-free at all times, i.e. that it will be constantly available without interruption. In particular, Jaty is not responsible for failures of technical equipment or the quality of access to services due to force majeure or events beyond Jaty's control (e.g. failure of communication networks).</p></li>
        <li><p>Jaty is not responsible for the unlawful acquisition of customer personal data by third parties, e.g. in the form of access to the database by hackers.</p></li>
        <li><p>For losses other than those resulting from the above-mentioned reasons, Jaty will be liable only in cases of intentional or gross negligence on the part of its management, employees or contractors, and such liability is proportional to the other reasons that contributed to the loss.</p></li>
        <li><p>Jaty is only liable for slight negligence in the event of damage to life, body or health or in the event that it has breached essential contractual obligations. Liability in the latter case is limited to the foreseeable, direct losses typical of this type of contractual relationship.</p></li>
        <li><p>Contractual liability is otherwise excluded.</p></li>
      </ol>
    </section>

    <section id="pkt-6" class="legal-doc__section">
      <h3>6. Customer Responsibilities</h3>
      <ol class="legal-doc__clauses">
        <li>
          <p>The customer is solely responsible for all data provided by him. She/he ensures that the data provided by him is correct. The customer undertakes not to provide the data of third parties as his own. Providing false data violates the provisions of the contract and the General Terms and Conditions and may require the Jaty Website to take appropriate legal steps.</p>
          <p>The customer undertakes to keep the data provided on the Jaty Website, in particular contact details, up-to-date.</p>
          <p>The Jaty website is entitled to check the content of the profile, including the posted photos, in terms of their compliance with the law, General Conditions and the contract. Jaty's website is entitled to reject, change and even delete the content of the data.</p>
        </li>
        <li><p>Public profile descriptions must not contain contact details for communicating outside Jaty. Section 6a explains this rule and the rules for exchanging contact details privately.</p></li>
        <li><p>The Customer is obliged to treat confidential data (in particular names, home addresses, e-mail addresses, website addresses, telephone numbers) regarding e-mail, messages and notifications received from other Customers of the Jaty Website and to not to disclose this data to third parties without the consent of the data subject. It is forbidden to disclose the data of persons who are not Clients of the Jaty Website.</p></li>
        <li><p>The Customer must not use Jaty for advertising, commercial spam or recruitment to other services. <a href="#moderacja-wiadomosci">Section 6a.3</a> sets out the rules for private messages.</p></li>
        <li>
          <p>The Client undertakes not to use the Jaty Service for the purpose of:</p>
          <ul>
            <li>sending unlawful or defamatory material or content that violates section 6a;</li>
            <li>threats, harassment, defamation etc.;</li>
            <li>obtaining money, data or access to accounts through deception, coercion or blackmail;</li>
            <li>violating the rights of third parties.</li>
          </ul>
          <p>The customer also undertakes:</p>
          <ul>
            <li>not to introduce data containing viruses (infected software) to the Website;</li>
            <li>not to enter data containing software or other materials protected by copyright or industrial property rights to the Jaty Website, unless the Customer is the owner of a given right or has the necessary consent of the holder of the right to use the software or materials;</li>
            <li>not to use the Jaty Website in a way that may adversely affect the availability of the Jaty Website offer to other Customers;</li>
            <li>not to interfere with the computer system of other Clients, in particular not to take illegal actions related to the e-mail of other Clients.</li>
          </ul>
        </li>
        <li><p>The response to a violation is determined under section 6a: removal of a description or photos and a warning, a ban, or referral for human review. These rules do not exclude remedies available under applicable law.</p></li>
        <li><p>If the Customer uses data from the Jaty Service for commercial purposes, Jaty may pursue remedies available under applicable law.</p></li>
        <li><p>The customer undertakes to release the Jaty Website from any effects of lawsuits, claims for damages, losses and receivables that arise in connection with his registration on the Jaty Website and use of it. The customer indemnifies the Jaty Service from all civil liability and from all liabilities and damages that may arise as a result of claims arising from slander or insult, and from violating the rights of other customers.</p></li>
        <li>
          <p>The client should receive incoming messages and reply to them regularly and, if necessary, archive them on his own computer or other data carrier.</p>
          <p>Jaty may archive or delete older content, including messages, and delete inactive accounts.</p>
        </li>
      </ol>
    </section>

    <section id="moderacja" class="legal-doc__section legal-doc__section--highlight">
    <h3>6a. Profiles, messages and moderation rules</h3>
    <p>Jaty is for adults aged 18 and over. Below we describe which content is not allowed and how we respond to violations. Public profiles and private conversations follow different rules.</p>
    <h4 id="moderacja-opisy">6a.1. Profile name and description</h4>
    <p>Your name and description should present you truthfully. In particular, public profiles must not contain:</p>
    <ul>
      <li>contact details for communicating outside Jaty (e.g. phone, email, messaging apps, social media), including disguised ones;</li>
      <li>sexual, vulgar or obscene content;</li>
      <li>advertising, spam, recruitment to other services or offers of paid services or erotic content;</li>
      <li>threats, harassment, fraud or other unlawful content.</li>
    </ul>
    <h4 id="moderacja-zdjecia">6a.2. Profile photos</h4>
    <p>Profile photos are public and must be appropriate for a public place. In particular, nudity, sexual or obscene content, inappropriate clothing, violence and any content sexualising minors are not allowed. This also applies to drawings and computer-generated images. Photos should show you – photos of other people (e.g. public figures) and contact details placed on a photo are not allowed.</p>
    <h4 id="moderacja-wiadomosci">6a.3. Private messages</h4>
    <p>Private conversations between adults may be open, including exchanging contact details, flirting and sexual conversations – as long as they are voluntary and within the law. The restrictions on public profiles do not apply to private conversations.</p>
    <p>In particular, spam, advertising, fraud and scams (e.g. obtaining money, login details or BLIK codes), blackmail, threats and harassment are not allowed – including continuing to send sexual content to someone who has clearly refused.</p>
    <h4 id="moderacja-autentycznosc">6a.4. Account authenticity</h4>
    <p>Impersonating other people, running automated accounts (bots) and creating additional accounts to evade a ban, send spam or mislead others are prohibited.</p>
    <p>We may ask you to confirm that the account belongs to the person in the photos, for example when the connection location does not match the city in the profile. Until verification, sending messages may be restricted, and failing or refusing verification may result in the account being blocked.</p>
    <h4 id="moderacja-ai">6a.5. How we use AI</h4>
    <p>We use artificial intelligence tools that check descriptions, photos, messages and account activity to detect violations. Decisions may be made automatically or by a moderator.</p>
    <p>AI can make mistakes – so you can appeal any decision, and appeals are reviewed by a human (section 6a.7).</p>
    <h4 id="moderacja-kontekst">6a.6. Responses to violations</h4>
    <p>Depending on the severity of a violation, we may remove content (a description or photos), issue a warning or block the account (ban). A serious violation, or a repeated violation after a warning, may result in a ban. We assess content in context, not isolated words. A ban blocks access to the account. People who had a pair or conversation with a blocked account receive a notification about the block on the site, together with the name or nickname and a thumbnail of the profile photo, without the reason for it. The notification is removed if the block is lifted.</p>
    <h4 id="moderacja-odwolanie">6a.7. Reports and appeals</h4>
    <p>We notify you of a warning or ban by email. You can report a violation or appeal a decision by emailing <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Appeals are free and do not require logging in.</p>
    <p>Include your username or account email and explain why you disagree with the decision. Do not send your password. Appeals are reviewed by a human who can change the decision. We communicate the outcome by email.</p>
    <p>Information about the data used in moderation is available in the <a href="/en/polityka-prywatnosci#moderacja-dane">privacy policy</a>.</p>
    </section>

    <section id="pkt-7" class="legal-doc__section">
      <h3>7. Information on data protection, data processing and cookies</h3>
      <p>Information about the processing of personal data can be found in our <a href="/en/polityka-prywatnosci">privacy policy</a>.</p>
    </section>

    <section id="pkt-8" class="legal-doc__section">
      <h3>8. Termination of the contract and cessation of services</h3>
      <h4>8.1. Termination</h4>
      <p>The contract for using the Jaty Service is free of charge and begins when the Customer registers.</p>
      <p>The Customer may terminate the contract at any time without giving a reason by deleting their account in the account settings (“Delete account”). For 30 days, people the Customer had a pair or conversation with see a notification about the account deletion, together with the name or nickname from the profile. When an account is deleted, we keep only general information for statistical purposes – gender, age, city and the stated reason for leaving – in a form that cannot be linked to a specific person.</p>
      <p>Jaty may terminate the contract with 14 days’ notice. Jaty may also terminate the contract at any time in the circumstances specified in these General Terms and Conditions and the contract.</p>
      <h4>8.2. Duration of the contract</h4>
      <p>The contract continues until terminated by the Customer or Jaty in accordance with these General Terms and Conditions. Jaty does not currently use paid subscriptions, automatic renewals of paid services or trial subscriptions.</p>
      <h4>8.3. Cessation of services</h4>
      <p>Jaty may discontinue some or all of its services. Jaty will inform the Customer about the planned cessation and its scope at least 14 days in advance.</p>
    </section>

    <section id="pkt-9" class="legal-doc__section">
      <h3>9. Complaints</h3>
      <ol class="legal-doc__clauses">
        <li>
          <p>The Customer may submit complaints by email or post to:</p>
          <p class="legal-doc__address">WHIPO sp. z o.o. – Jaty, ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118<br>Email: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a></p>
        </li>
        <li>
          <p>A complaint should describe the problem, provide information allowing the Customer’s account to be identified and state the requested resolution. We respond to complaints within 14 days of receipt.</p>
          <p>The Customer may give Jaty five working days to restore the proper operation of the service. If the problem is not resolved within that period, the Customer may terminate the contract.</p>
          <p>Complaints may concern the operation of the Jaty Service, including individual features. These General Terms and Conditions do not limit the Customer’s rights under mandatory provisions of applicable law.</p>
        </li>
      </ol>
    </section>

    <section id="pkt-10" class="legal-doc__section">
      <h3>10. Copyright</h3>
      <ol class="legal-doc__clauses">
        <li><p>All rights to the Jaty Website's programs, procedures, software content, technologies, brands, trade names, inventions, materials and any other intellectual property rights that are part of the Jaty Website are vested solely by the Jaty Website. The use of any programs and their content, materials, brands and trade names is allowed only for the purposes indicated in these General Terms and Conditions. Reproduction of programs, benefits, procedures, software, technologies, brands, trade names, inventions and materials belonging to the Jaty Website is prohibited, unless expressly permitted by the Jaty Website.</p></li>
      </ol>
    </section>

    <section id="pkt-11" class="legal-doc__section">
      <h3>11. The right to withdraw from the contract, information on the exercise of the right to withdraw from the contract</h3>
      <h4>Right of withdrawal</h4>
      <p>The customer has the right to withdraw from the contract within fourteen days without giving any reason.</p>
      <p>The withdrawal period is fourteen days from the date of the conclusion of the contract.</p>
      <p>To withdraw from the contract, send a clear statement of your decision by post to WHIPO sp. z o.o. – Jaty, ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118, or by email to <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Sending the statement before the withdrawal period expires is sufficient to meet the deadline.</p>
      <h4>Consequences of withdrawal</h4>
      <p>In the event of withdrawal, the contract is treated as if it had not been concluded and access to the account ends. Instead of sending a statement, you can also simply delete your account. The <a href="/en/polityka-prywatnosci">privacy policy</a> describes the processing of personal data after use of the service ends.</p>
    </section>

    <section id="pkt-12" class="legal-doc__section">
      <h3>12. Change of the General Conditions</h3>
      <ol class="legal-doc__clauses">
        <li><p>The General Conditions contained in the Regulations may be amended if they do not affect the essential provisions of the contractual relationship and that such a change is necessary in order to adapt issues not provided for at the time of the conclusion of the contract, which would significantly breach the balance of the contractual relationship should they remain unaccounted for. “Essential provisions” are in particular those relating to the type and scope of the contractually agreed services and their duration, including the provisions governing their termination. Further modifications or additions to the Regulations may take place if it is necessary to solve difficulties related to the performance of the contract, caused by gaps arising after the conclusion of the contract. In particular, this may be the case when the legislation is changed and it affects one or more points of the Regulations.</p></li>
        <li><p>The specifications for the services may be changed if there is a justified need, provided that these changes do not result in an objectively less favorable situation for the customer (e.g. the need to service or improve the functionality of the website) than it was caused by the specifications of services in force at the time of concluding contract and they do not differ significantly from the previous specifications. A justified need to make changes occurs when technical innovations are available on the market or when third parties, from whom Jaty obtains advanced services necessary for the proper functioning of the website, change the scope of their services.</p></li>
        <li><p>The customer must be informed of the changes to the Regulations and the specifications of the services in accordance with paragraph 12. (1) and (2) at least six (6) weeks before their entry into force. If the Customer does not accept the changes, they may terminate the contract by deleting their account before the changes take effect. Otherwise, the changes will become part of the contract when they come into effect. The customer will be expressly notified of this effect via a notification of the changes.</p></li>
      </ol>
    </section>

    <section id="pkt-13" class="legal-doc__section">
      <h3>13. Others</h3>
      <ol class="legal-doc__clauses">
        <li><p>Jaty has the right to commission third parties, who are its service providers and contractors, to provide part or all of the scope of the services provided, provided that this does not cause any disadvantages to the client.</p></li>
        <li><p>If individual provisions of these Terms and Conditions or the contract are or become invalid, the validity of the remaining provisions shall remain binding on the parties.</p></li>
        <li><p>The applicable law in the relationship between the Customer and Jaty's Website is Polish law, subject to the mandatory provisions of the EU Regulation No. 593/2008.</p></li>
        <li><p>These General Terms and Conditions do not exclude or limit the Customer’s rights under mandatory provisions of applicable law.</p></li>
        <li><p>The owner and operator of the Jaty Service is WHIPO sp. z o.o., a Polish limited liability company with its registered office at ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118.</p></li>
      </ol>
    </section>
  </article>`,

  privacy_policy_content: `<article class="legal-doc">
    <header class="legal-doc__header">
      <h2 class="legal-doc__title">Privacy policy of www.jaty.pl</h2>
    </header>

    <nav class="legal-doc__toc" aria-label="Table of contents">
      <p class="legal-doc__toc-title">Contents</p>
      <ol>
        <li><a href="#administrator">1. Data controller</a></li>
        <li><a href="#zakres-danych">2. What data we process</a></li>
        <li><a href="#cele">3. Purposes and legal bases</a></li>
        <li><a href="#okres">4. How long we keep data</a></li>
        <li><a href="#odbiorcy">5. Recipients of data</a></li>
        <li><a href="#poza-eog">6. Transfers outside the EEA</a></li>
        <li><a href="#decyzje-automatyczne">7. Automated decisions</a></li>
        <li><a href="#prawa">8. Your rights</a></li>
        <li><a href="#usuniecie-konta">9. Deleting your account</a></li>
        <li><a href="#pozostale">10. Security, links and policy changes</a></li>
        <li><a href="#moderacja-dane">11. Data used in AI moderation</a></li>
        <li><a href="#analityka">12. Visit statistics and external tools</a></li>
        <li><a href="#zrodlo-rejestracji">13. Registration source information</a></li>
      </ol>
    </nav>

    <section id="administrator" class="legal-doc__section">
      <h3>1. Data controller</h3>
      <p>The controller of personal data processed in the Jaty Service is WHIPO sp. z o.o., a Polish limited liability company with its registered office at ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118. For matters concerning personal data, you may contact the controller at this postal address or by email: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
      <p>This policy explains what data we process when you use the Jaty dating service, for what purposes, for how long and what rights you have.</p>
    </section>

    <section id="zakres-danych" class="legal-doc__section">
      <h3>2. What data we process</h3>
      <ul>
        <li><strong>Account data</strong> – email address, password (encrypted), first name, gender, who you are looking for, date of birth, city and search preferences. If you sign in with Facebook, we receive basic data needed to create the account from Facebook, such as your name and email address.</li>
        <li><strong>Profile</strong> – description, photos and any additional information you choose to provide (e.g. height, education, religion).</li>
        <li><strong>Activity in the service</strong> – hearts, matches, messages, profile views, blocks and last activity time.</li>
        <li><strong>Moderation and security</strong> – reports, warnings, moderation decisions and their reasons, the connection country determined from the IP address and a verification photo if we ask for one.</li>
        <li><strong>Technical data</strong> – cookies and similar technologies described in the <a href="/en/cookies">cookie policy</a>, notification settings and a push notification subscription if you enable it.</li>
        <li><strong>Correspondence</strong> – the content of messages you send us by email or through the contact form, including complaints and appeals.</li>
      </ul>
      <p>Providing account data is voluntary but necessary to use the service. Other profile information is up to you.</p>
      <p>Some information, such as religion or who you are looking for (which may indicate sexual orientation), belongs to special categories of data. You provide it voluntarily and it is visible in your profile; we process it based on your explicit consent, which you can withdraw by removing the information from your profile or deleting your account.</p>
    </section>

    <section id="cele" class="legal-doc__section">
      <h3>3. Purposes and legal bases</h3>
      <table class="legal-doc__table">
        <thead>
          <tr><th scope="col">Purpose</th><th scope="col">Legal basis (GDPR)</th></tr>
        </thead>
        <tbody>
          <tr><td>Creating and running the account, profile, matching, messages and notifications</td><td>performance of a contract – Art. 6(1)(b)</td></tr>
          <tr><td>Special categories of data provided in the profile</td><td>explicit consent – Art. 9(2)(a)</td></tr>
          <tr><td>Content moderation, protection against spam, fraud and fake accounts, account verification</td><td>legitimate interest (safety of users and the service) – Art. 6(1)(f)</td></tr>
          <tr><td>Informing people who had a pair or conversation with an account that it was deleted or blocked</td><td>legitimate interest (explaining why the pair and conversation disappeared, and protection against scams) – Art. 6(1)(f)</td></tr>
          <tr><td>Handling contact requests, complaints and appeals</td><td>performance of a contract and legal obligations – Art. 6(1)(b) and (c)</td></tr>
          <tr><td>Google Analytics and registration source measurement</td><td>consent – Art. 6(1)(a)</td></tr>
          <tr><td>Aggregate visit statistics (Simple Analytics)</td><td>legitimate interest – Art. 6(1)(f)</td></tr>
          <tr><td>Establishing, pursuing or defending legal claims</td><td>legitimate interest – Art. 6(1)(f)</td></tr>
        </tbody>
      </table>
      <p>We do not sell users’ personal data or use it for advertising.</p>
    </section>

    <section id="okres" class="legal-doc__section">
      <h3>4. How long we keep data</h3>
      <ul>
        <li><strong>Account data, profile, activity and messages</strong> – until the account is deleted.</li>
        <li><strong>Moderation history</strong> (reports, warnings, decisions and related logs, including after a ban) – until the account is deleted. A person with a blocked account can request its deletion by emailing <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</li>
        <li><strong>Notice about a deleted or blocked account</strong> – the name or nickname from the profile, in a notification for people who had a pair or conversation with the account: for 30 days after deletion, and for a block (together with a thumbnail of the profile photo) until it is lifted or the account is deleted.</li>
        <li><strong>Verification photo</strong> – until a moderator makes a decision, after which it is deleted.</li>
        <li><strong>Correspondence, complaints and appeals</strong> – for as long as needed to handle them, and then until any claims become time-barred.</li>
        <li><strong>Analytics data</strong> – as described in the <a href="/en/cookies">cookie policy</a>; data saved with an account – until the account is deleted.</li>
        <li><strong>Backups</strong> – up to 12 months. They are used only to restore the service after a failure; the data in them is not otherwise used or processed during that time.</li>
      </ul>
      <p>The service may also delete inactive accounts and archive or delete older content in accordance with the terms.</p>
    </section>

    <section id="odbiorcy" class="legal-doc__section">
      <h3>5. Recipients of data</h3>
      <p>Data may be shared with entities that help us run the service and process it on our behalf or as separate controllers:</p>
      <ul>
        <li>hosting, server infrastructure and network protection and acceleration providers;</li>
        <li>email and browser push notification service providers;</li>
        <li>the provider of artificial intelligence tools used for moderation (section 11);</li>
        <li>analytics providers – Google Analytics only with consent, and Simple Analytics (section 12);</li>
        <li>Meta Platforms (Facebook) – if you sign in with Facebook;</li>
        <li>public authorities where required by law.</li>
      </ul>
      <p>Profile data is visible to other users of the service. Messages are seen only by their recipient; they are not published or shared with other users.</p>
    </section>

    <section id="poza-eog" class="legal-doc__section">
      <h3>6. Transfers outside the EEA</h3>
      <p>Some providers, e.g. of AI tools, analytics or infrastructure, may process data outside the European Economic Area, including in the USA. In that case the transfer relies on mechanisms provided for in the GDPR, such as a European Commission adequacy decision or standard contractual clauses.</p>
    </section>

    <section id="decyzje-automatyczne" class="legal-doc__section">
      <h3>7. Automated decisions</h3>
      <p>As part of moderation, AI tools may on their own decide to remove content, issue a warning or block an account, in line with the rules set out in the <a href="/en/regulamin#moderacja">terms</a>. You have the right to obtain human intervention, express your point of view and contest such a decision – email <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. We do not use profiling for marketing purposes.</p>
    </section>

    <section id="prawa" class="legal-doc__section">
      <h3>8. Your rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>access your data and receive a copy of it;</li>
        <li>rectify your data – you can change most of it yourself in the account settings;</li>
        <li>erasure of your data;</li>
        <li>restriction of processing;</li>
        <li>data portability;</li>
        <li>object to processing based on legitimate interest;</li>
        <li>withdraw consent at any time – without affecting the lawfulness of processing before withdrawal.</li>
      </ul>
      <p>To exercise these rights, email <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a> or use the <a href="/en/kontakt">contact form</a>. You may also lodge a complaint with the President of the Polish Personal Data Protection Office (UODO).</p>
    </section>

    <section id="usuniecie-konta" class="legal-doc__section">
      <h3>9. Deleting your account</h3>
      <p>You can delete your account at any time in the account settings (“Delete account”) or ask us to delete it by emailing <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Deleting the account removes the account data, profile, messages and moderation history, except for your name or nickname in the deletion notice that people you have a pair or conversation with see for 30 days (section 4); backups retain the data for no longer than the period stated in section 4.</p>
      <p>When an account is deleted, we keep only gender, age, city and the stated reason for leaving for statistical purposes, without data that could identify a specific person.</p>
    </section>

    <section id="pozostale" class="legal-doc__section">
      <h3>10. Security, links and policy changes</h3>
      <p>We use technical and organisational measures to protect data against unauthorised access, loss or destruction.</p>
      <p>Links to other websites may appear in the service. They operate independently of Jaty and have their own privacy rules, which we recommend reading.</p>
      <p>This policy may change, e.g. as the service develops or the law changes. We will announce material changes in the service or by email.</p>
    </section>

    <section id="moderacja-dane" class="legal-doc__section">
    <h3>11. Data used in AI moderation</h3>
    <p>To detect violations of the terms, spam and fraud, we check public descriptions, photos, account information, warning history and the content of sent private messages. Private messages are therefore subject to moderation even though they are not publicly visible.</p>
    <p>We use AI tools from an external provider, to which checked content and account data may be sent. The provider may process data outside the European Economic Area (section 6).</p>
    <p>The moderation rules are set out in the <a href="/en/regulamin#moderacja">terms</a>. For appeals, we record the assessed content, the reason for the decision and its outcome. A ban does not mean that all data is deleted. You can appeal a decision by emailing <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a> – appeals are reviewed by a human.</p>
    <p>To protect against fake accounts, we compare the country of the connection (based on the IP address) with the city stated in the profile. If they do not match, we may ask for a verification photo. A moderator reviews the photo, and it is deleted once a decision is made.</p>
    </section>

    <section id="analityka" class="legal-doc__section">
    <h3>12. Visit statistics and external tools</h3>
    <p>We use Simple Analytics for visit statistics. This measurement is separate from registration data saved with an account. We enable Google Analytics only after analytics consent and rely on consent for this processing. Measurement purposes and provider information about cookies and privacy are described in our <a href="/en/cookies">cookie policy</a>. Using the service or accepting this policy does not constitute consent to optional tracking.</p>
    </section>

    <section id="zrodlo-rejestracji" class="legal-doc__section">
    <h3>13. Registration source information</h3>
    <p>After analytics consent, when an account is created, we may save the first generic page path visited and the source from the utm_source parameter, such as a campaign name. These values are read from the first_page_visited and first_utm_source cookies. This also applies to registration through Facebook.</p>
    <p>The purpose is to understand where people creating accounts come from. This data is linked to an account and is not anonymous. Missing values do not block registration or account features. Source measurement is based on consent (Article 6(1)(a) GDPR). It is optional and is not a condition of entering into an agreement to use the service. Accepting the terms does not replace prior consent to optional cookie storage and access.</p>
    <p>Saved information remains part of the account data after the browser is closed or cookies are deleted. To request access, rectification, erasure or restriction of processing, email <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. These rights apply under the conditions set out in the GDPR. You may also lodge a complaint with the President of the Polish Personal Data Protection Office (UODO).</p>
    </section>
  </article>`,

  cookies_content: `
    <article class="legal-doc">
    <header class="legal-doc__header">
      <h2 class="legal-doc__title">JaTy cookie policy</h2>
    </header>
    <div class="legal-doc__intro">
      <p>Cookies are small pieces of information stored in your browser. They help keep you signed in and remember your choices, but can also support traffic measurement and advertising. The service operator is WHIPO sp. z o.o., ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Poland, tax identification number (NIP): 5342666118. Contact: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
    </div>

    <nav class="legal-doc__toc" aria-label="Table of contents">
      <p class="legal-doc__toc-title">Contents</p>
      <ol>
        <li><a href="#cookies-niezbedne">1. Your account and choices</a></li>
        <li><a href="#cookies-zrodlo">2. Registration source</a></li>
        <li><a href="#cookies-simple-analytics">3. Simple Analytics</a></li>
        <li><a href="#cookies-google-analytics">4. Google Analytics</a></li>
        <li><a href="#cookies-zgoda">5. Consent and managing data</a></li>
      </ol>
    </nav>

    <section id="cookies-niezbedne" class="legal-doc__section">
    <h3>1. Your account and choices</h3>
    <ul>
      <li><strong>Session and security</strong> – session, authentication and form protection cookies, including <code>XSRF-TOKEN</code>. These identify the signed-in user and protect requests to the service. Authentication cookies last up to 365 days; a session may end earlier, for example when you sign out.</li>
      <li><strong>Selected language</strong> – <code>preffered-lang</code> remembers the website language for 365 days after it is saved.</li>
      <li><strong>Dismissing the notification prompt</strong> – <code>notification-box-shown</code> remembers that you dismissed the prompt for 7 days. You grant permission for push notifications separately in your browser.</li>
      <li><strong>Registration link parameter</strong> – <code>free-month</code> may be saved for 1 day after you follow a link with the free_month parameter. This belongs to an older promotional mechanism; it does not activate payments or a subscription.</li>
    </ul>
    <p>We save your consent or refusal as <code>jaty-consent</code> in a cookie and browser local storage (localStorage) for 5 years (1825 days), so we do not ask on every visit. We ask again after expiry, clearing site data or a material change to the scope of consent. Your browser may remove the saved choice earlier.</p>
    </section>

    <section id="cookies-zrodlo" class="legal-doc__section">
    <h3>2. Registration source – with analytics consent</h3>
    <p>After analytics consent, the <code>first_page_visited</code> cookie remembers the first page path visited, while <code>first_utm_source</code> remembers the first utm_source value encountered in a link, such as a campaign name. These are session cookies; your browser may retain them when restoring a session.</p>
    <p>During registration, including registration through Facebook, available values are sent to JaTy and saved with the account as the first page visited and the user acquisition source. This measurement is linked to an account and is therefore not an anonymous statistic. It is not needed to create an account, sign in or chat. Deleting browser cookies does not delete information already saved with the account.</p>
    </section>

    <section id="cookies-simple-analytics" class="legal-doc__section">
    <h3>3. Simple Analytics</h3>
    <p>We use Simple Analytics for aggregate visit statistics. According to its documentation, it uses no cookies or persistent visitor identifiers. Our integration respects Do Not Track (DNT), replaces profile addresses and tokens with generic paths, and disables UTM and referrer metrics. This is separate from the account attribution described above. <a href="https://docs.simpleanalytics.com/privacy" rel="noreferrer">Simple Analytics privacy information</a>.</p>
    </section>

    <section id="cookies-google-analytics" class="legal-doc__section">
    <h3>4. Google Analytics – with analytics consent</h3>
    <p>We load Google Analytics only after consent to measure visits and website use. The <code>_ga</code> and <code>_ga_*</code> cookies distinguish browsers and link page views; we set their lifetime to 180 days. Google receives measurement data. We do not send account identifiers, message content or profile names for measurement; we report generic page paths.</p>
    <p>Analytics consent does not include ad personalisation. We do not use Google Ads, AdSense, Hotjar or Facebook Pixel. Facebook sign-in remains a separate function initiated at your request.</p>
    <p>Provider information about cookies and data processing: <a href="https://policies.google.com/technologies/cookies?hl=en" rel="noreferrer">Google cookies</a> and <a href="https://policies.google.com/privacy?hl=en" rel="noreferrer">Google privacy policy</a>.</p>
    </section>

    <section id="cookies-zgoda" class="legal-doc__section">
    <h3>5. Consent and managing data</h3>
    <p>Analytics is off by default. Choose “Accept all”, “Essential only” or your own settings. Analytics consent covers Google Analytics and registration source measurement. Accepting the terms or privacy policy does not replace that consent. An exception applies to operations necessary for transmission or to provide a service requested by the user.</p>
    <p>You can open “Cookie settings” on the cookie policy page or in your account menu at any time and withdraw consent as easily as granting it. We then stop further Google Analytics measurement and source attribution and remove analytics cookies accessible to the service. This does not automatically erase previously collected data or information saved with your account. Withdrawal does not affect the lawfulness of processing before withdrawal.</p>
    <p>Your browser privacy settings let you inspect, delete and block cookies and check their expiry dates. Blocking session and security cookies may prevent sign-in; deleting language preferences may require you to select a language again. Browser settings do not replace the service’s obligation to obtain consent for optional technologies.</p>
    <p>For information about data saved with your account and contacting the controller, see our <a href="/en/polityka-prywatnosci#zrodlo-rejestracji">privacy policy</a>.</p>
    </section>
    </article>`,

  // shame
  'Normalna': 'Normal',
  'Muskularna': 'Muscular',
  'Lekko puszysta': 'Slightly fluffy',
  'Puszysta': 'Fluffy',
  '120 i mniej': '120 and less',
  '211 i więcej': '211 and more',
  'Posiadam dzieci': 'I have children',
  'Chce mieć': 'I want to have',
  'Jeszcze nie wiem': 'I don\'t know yet',
  'Brązowe (piwne)': 'Brown (hazel)',
  'Niebieskie': 'Blue',
  'Szare': 'Gray',
  'Mieszane': 'Mixed',
  'Panna / Kawaler': 'Miss / Mister',
  'Kawaler': 'Single',
  'Panna': 'Miss',
  'Rozwiedziony': 'Divorced',
  'Rozwiedziona': 'Divorced',
  'Wdowiec': 'Widower',
  'Wdowa': 'Widow',
  'Mam żonę': 'I have a wife',
  'Mam męża': 'I have a husband',
  'Rozwódka / Rozwodnik': 'Divorced',
  'Wdowa / Wdowiec': 'Widow',
  'Separacja': 'Separation',
  'Uczeń / Student': 'Studentg',
  'Emeryt': 'Retired',
  'Rencista': 'Pensioner',
  'Niepracujący': 'Not working',
  'Przedsiębiorca': 'Entrepreneur',
  'Usługi': 'Services',
  'Handel': 'Trade',
  'Pracownik biurowy': 'Office worker',
  'Pracownik fizyczny': 'Manual worker',
  'Służba mundurowa': 'Uniformed Service',
  'Służba zdrowia': 'Healthcare',
  'Edukacja': 'Education',
  'Kierownik / Manager': 'Manager',
  'Dyrektor / Prezes': 'Director / President',
  'Działalność artystyczna': 'Artistic activity',
  'Działalność publiczna': 'Public activity',
  'Marketingowiec / PR\'owiec': ' Marketing / PR',
  'Działalność naukowa': 'Scientific activity',
  'Inne': 'Other',
  'Bardzo chcę małżeństwa': 'I want marriage very much',
  'Dopuszczam myśl o małżeństwie': 'I allow the thought of marriage',
  'Nie chcę małżeństwa': 'I don\'t want marriage',
  'Podstawowe': 'Basic',
  'Średnie': 'Medium',
  'Pomaturalne': 'Medium finished',
  'Licencjat': 'Bachelor',
  'Podyplomowe': 'Postgraduate',
  'Wyższe niepełne': 'Higher incomplete',
  'Wyższe': 'Higher',
  'Katolicyzm': 'Catholicism',
  'Prawosławie': 'Orthodoxy',
  'Protestantyzm': 'Protestantism',
  'Świadek Jechowy': 'Jehovah\'s Witness',
  'Buddyzm': 'Buddhism',
  'Hinduizm': 'Hinduism',
  'Islam': 'Islam',
  'Judaizm': 'Judaism',
  'Ateizm': 'Atheism',
  'Nie chcę mówić': 'I don\'t want to say',
  'Inna': 'Other',

  images: {
    hero: '/portal-randkowy/assets/img/hero_en.webp',
    mobile_jaty: '/portal-randkowy/assets/img/mobile-jaty_en.webp',
    chat: '/portal-randkowy/assets/img/chat_en.webp',
    play_badge: '/en/google/play_badge.png'
  }
}
